var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Document Icon",
    d: "M11 0H22H33H37C38.1046 0 39 0.89543 39 2V9.5H42C43.1046 9.5 44 10.3954 44 11.5V22C44 23.1046 43.1046 24 42 24H39V40V42C39 43.1046 38.1046 44 37 44H33H22H11H6.75C5.23122 44 4 42.7688 4 41.25H1C0.447715 41.25 0 40.8023 0 40.25V39.5C0 38.9477 0.447715 38.5 1 38.5H4V35.75H1C0.447715 35.75 0 35.3023 0 34.75V34C0 33.4477 0.447715 33 1 33H4V30.5H1C0.447715 30.5 0 30.0523 0 29.5V29C0 28.4477 0.447715 28 1 28H4V25.5H1C0.447715 25.5 0 25.0523 0 24.5V24C0 23.4477 0.447715 23 1 23H4V20H1C0.447715 20 0 19.5523 0 19V18C0 17.4477 0.447715 17 1 17H4V14H1C0.447715 14 0 13.5523 0 13V12C0 11.4477 0.447715 11 1 11H4V8.25H1C0.447715 8.25 0 7.80228 0 7.25V6.5C0 5.94772 0.447715 5.5 1 5.5H4V3C4 1.34315 5.34315 0 7 0H11Z",
    fill: "#C7CCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.52887be3b138cf7dac2a643671a95c98.svg";
export { ForwardRef as ReactComponent };